import React, { useRef } from "react";
import Sidebar from "../sidebar/Sidebar";
import { useState, useEffect } from "react";
import { Services } from "../../api/Services";
import { ToastContainer, toast } from "react-toastify";
import gymimage from "../../images/gymgirl.jpg";
import placholder from "../../images/placeholder.png";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useParams } from "react-router-dom";
import { BASE_URL_MEDIA } from "../../api/Constants";
import { getImageUrl } from 'components/helpers/Helpers';
import ProgramTagsSection from "./ProgramTagsSection";
import { set } from "date-fns";
import ErrorModal from "../common/ErrorModal/ErrorModal";
import "./EditProgramm.css";
import "components/Attachments/UploadAttachment.css";
import VideoUploadPopup from "../workout/VideoUploadPopup";

const EditProgramm = () => {
  const fileInputRef = useRef(null);
  const [initialValues, setInitialValues] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const [communitylist, setCommunityList] = useState([]);
  const [groupList, setGrouplist] = useState([]);
  const [groupId, setGroupId] = useState("");
  const [isLoading, setisLoading] = useState(false);
  const [communityId, setCommunityId] = useState(null);
  const [userinput, setUserinput] = useState("");

  const [programStartDate, setprogramStartDate] = useState("");
  const [users, setUsers] = useState([]);
  const [selectedusers, setSelectedusers] = useState([]);
  const [usersIds, setUsersIds] = useState([]);

  const [numberOfWeeks, setNumberOfWeeks] = useState("");
  const [name, setName] = useState("");
  const [isFree, setIsFree] = useState(null);
  const [lock, setLock] = useState("");
  const [assign, setAssign] = useState("self");
  const [price, setPrice] = useState(0);
  const [description, setDescription] = useState("");
  const [video, setVideo] = useState("");
  const [selectedVideoFile, setSelectedVideoFile] = useState(null);
  const [selectedVideoUrl, setSelectedVideoUrl] = useState(null);
  const [showVideoUploadPopup, setShowVideoUploadPopup] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [image, setImage] = useState(null);
  const [selectedimage, setSelectedimage] = useState("");
  const [isdisabled, setisdisabled] = useState(false);
  const [isOpenSource, setIsOpenSource] = useState(0);

  const [activityLevels, setActivityLevels] = useState([]);
  const [ageRanges, setAgeRanges] = useState([]);
  const [genders, setGenders] = useState([]);
  const [bmiRanges, setBmiRanges] = useState([]);
  const [bmrRanges, setBmrRanges] = useState([]);
  const [dcrRanges, setDcrRanges] = useState([]);
  const [fitnessGoals, setFitnessGoals] = useState([]);

  const currentDate = new Date();

  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(currentDate.getDate()).padStart(2, "0");

  const formattedDate = `${year}-${month}-${day}`;

  // ErrorModal state
  const [showErrorModal, setErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [pendingBack, setPendingBack] = useState(false);

  // Program video upload handlers
  const handleProgramDivClick = () => {
    fileInputRef.current?.click();
  };

  const handleProgramSelectVideo = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setSelectedVideoFile(file);
      setSelectedVideoUrl(url);
    }
  };

  const handleProgramVideoUploaded = async (uploadedUrl) => {
    // Set uploaded URL and persist changes
    setVideo(uploadedUrl);
    setShowVideoUploadPopup(false);
    setSelectedVideoFile(null);
    try {
      await editProg(
        id,
        name,
        usersIds.join(","),
        image,
        description,
        uploadedUrl,
        groupId,
        isFree,
        price,
        isFree == "0" ? lock : "",
        communityId,
        programStartDate,
        numberOfWeeks,
        isOpenSource, // allow both Free & Paid to be Public/Private
        activityLevels,
        ageRanges,
        genders,
        bmiRanges,
        bmrRanges,
        dcrRanges,
        fitnessGoals
      );
    } catch (e) {
      // handled inside editProg
    }
  };

  const handleCloseVideoUploadPopup = () => {
    setShowVideoUploadPopup(false);
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
    setisdisabled(true);
    setisLoading(true);
    setSelectedimage(URL.createObjectURL(event.target.files[0]));
  };

  //select user
  const toggleItem = (item) => {
    if (selectedusers.includes(item)) {
      setSelectedusers(
        selectedusers.filter((selectedItem) => selectedItem !== item)
      );
      setUsersIds(usersIds?.filter((selectedId) => selectedId !== item?.id));
    } else {
      setSelectedusers((prevSelectedUsers) => [...prevSelectedUsers, item]);
      setUsersIds((prevUsersIds) => [...prevUsersIds, item?.id]);
    }
  };

  //remove
  const removeUser = (item) => {
    const confirmed = window.confirm("Do you want to remove user?");
    if (confirmed) {
      if (selectedusers.includes(item)) {
        setSelectedusers(
          selectedusers.filter((selectedItem) => selectedItem !== item)
        );
        const removedids = usersIds.filter(
          (selectedId) => selectedId !== item?.id
        );
        setUsersIds(removedids);
      }
    }
  };
  //Upload image api
  const uploadimg = async (data) => {
    try {
      const result = await Services.uploadImage(data);

      if (result.status === 200) {
        setImage(result?.data?.data?.image);
        setSelectedFile(null);
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setisdisabled(false);
      setisLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  if (selectedFile) {
    const uploadimagee = new FormData();
    uploadimagee.append("image", selectedFile);
    uploadimg(uploadimagee);
  }

  //handle if free or paid
  const handleFree = (event) => {
    const value = event.target.value;
    setIsFree(value);
    // Both Free and Paid can be Public or Private now, so do not force isOpenSource
  };

  const handleOpenSource = (value) => {
    setIsOpenSource(value);
  };

  //handle Lock or not
  const handleLock = (event) => {
    setLock(event.target.value);
  };
  //handle group

  const handleGroupChange = (event) => {
    const newSelectedId = parseInt(event.target.value, 10);
    setGroupId(newSelectedId);
  };
  const handleCommunityChange = (event) => {
    const newSelectedId = parseInt(event.target.value, 10);
    setCommunityId(newSelectedId);
  };

  const handleAssign = (event) => {
    setAssign(event.target.value);
  };

  // Hanlde user input
  const handleuserinputChange = async (event) => {
    setUserinput(event.target.value);

    try {
      const result = await Services.getProgrammUsers(userinput, 1);

      if (result?.status === 200) {
        setUsers(result?.data?.data?.listing);
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  // programm detail by id
  const programmDetail = async (program_id, day, week) => {
    try {
      const result = await Services.getProgrammDetail(program_id, day, week);
      console.log(result);
      if (result.status === 200) {
        setName(result?.data?.data?.name);

        setIsFree(result?.data?.data?.is_free);
        setPrice(result?.data?.data?.price);
        setCommunityId(result?.data?.data?.community_id);
        setLock(result?.data?.data?.lock_future_weeks);
        result?.data?.data?.desc !== "null"
          ? setDescription(result?.data?.data?.desc)
          : setDescription("");
        setprogramStartDate(result?.data?.data?.start_progress_date);
        setNumberOfWeeks(result?.data?.data?.number_of_weeks);
        setImage(result?.data?.data?.image);
        setVideo(result?.data?.data?.video);
        setIsOpenSource(result?.data?.data?.is_open_source ?? 0);

        // Split activity_levels by comma if it's a string
        const activityLevels = typeof result?.data?.data?.tags?.activity_levels === 'string'
          ? result?.data?.data?.tags?.activity_levels.split(',').map(s => s.trim()).filter(Boolean)
          : Array.isArray(result?.data?.data?.tags?.activity_levels)
            ? result?.data?.data?.tags?.activity_levels
            : [];
        setActivityLevels(activityLevels);

        // Split genders by comma if it's a string
        const genders = typeof result?.data?.data?.tags?.genders === 'string'
          ? result?.data?.data?.tags?.genders.split(',').map(s => s.trim()).filter(Boolean)
          : Array.isArray(result?.data?.data?.tags?.genders)
            ? result?.data?.data?.tags?.genders
            : [];
        setGenders(genders);

        // Split fitness_goals by comma if it's a string
        const fitnessGoals = typeof result?.data?.data?.tags?.fitness_goals === 'string'
          ? result?.data?.data?.tags?.fitness_goals.split(',').map(s => s.trim()).filter(Boolean)
          : Array.isArray(result?.data?.data?.tags?.fitness_goals)
            ? result?.data?.data?.tags?.fitness_goals
            : [];
        setFitnessGoals(fitnessGoals);




        const ageRanges = typeof result?.data?.data?.tags?.age_ranges === 'string'
          ? result?.data?.data?.tags?.age_ranges.split(',').map(s => s.trim()).filter(Boolean)
          : Array.isArray(result?.data?.data?.tags?.age_ranges)
            ? result?.data?.data?.tags?.age_ranges
            : [];
        setAgeRanges(ageRanges);

        setInitialValues({
          name: result?.data?.data?.name ?? "",
          description: result?.data?.data?.desc !== "null" ? result?.data?.data?.desc : "",
          video: result?.data?.data?.video ?? "",
          image: result?.data?.data?.image,
          price: result?.data?.data?.price ?? 0,
          numberOfWeeks: result?.data?.data?.number_of_weeks ?? "",
          programStartDate: result?.data?.data?.start_progress_date ?? "",
          communityId: result?.data?.data?.community_id ?? null,
          groupId: result?.data?.data?.group_id ?? "",
          usersIds: (result?.data?.data?.usersIds || []),
          assign: "self",
          isOpenSource: result?.data?.data?.is_open_source ?? 0,
          activityLevels,
          ageRanges,
          genders,
          bmiRanges: result?.data?.data?.tags?.bmi_ranges ? [result?.data?.data?.tags?.bmi_ranges] : [],
          bmrRanges: result?.data?.data?.tags?.bmr_ranges ? [result?.data?.data?.tags?.bmr_ranges] : [],
          dcrRanges: result?.data?.data?.tags?.dcr_ranges ? [result?.data?.data?.tags?.dcr_ranges] : [],
          fitnessGoals,
        });

        const age_ranges = typeof result?.data?.data?.tags?.age_ranges === 'string'
        ? result?.data?.data?.tags?.age_ranges.split(',').map(s => s.trim()).filter(Boolean)
        : Array.isArray(result?.data?.data?.tags?.age_ranges)
          ? result?.data?.data?.tags?.age_ranges
          : [];
        setAgeRanges(age_ranges);

        //setAgeRanges([result?.data?.data?.tags?.age_ranges] || []);
        setBmiRanges(result?.data?.data?.tags?.bmi_ranges ? [result?.data?.data?.tags?.bmi_ranges] : []);
        setBmrRanges(result?.data?.data?.tags?.bmr_ranges ? [result?.data?.data?.tags?.bmr_ranges] : []);
        setDcrRanges(result?.data?.data?.tags?.dcr_ranges ? [result?.data?.data?.tags?.dcr_ranges] : []);

        console.log("initialValues set:",initialValues?.name);


      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    programmDetail(id);
  }, []);

  //Create programm api

  const editProg = async (
    id,
    name,
    users,
    image,
    description,
    video,
    groupId,
    isFree,
    price,
    lock_future_weeks,
    communityId,
    programStartDate,
    number_of_weeks,
    isOpenSource,
    activityLevels,
    ageRanges,
    genders,
    bmiRanges,
    bmrRanges,
    dcrRanges,
    fitnessGoals
  ) => {
    setisLoading(true);
    try {
      const result = await Services.editProgram(
        id,
        name,
        users,
        image,
        description,
        video,
        groupId,
        isFree,
        price,
        lock_future_weeks,
        communityId,
        programStartDate,
        number_of_weeks,
        isOpenSource,
        activityLevels,
        ageRanges,
        genders,
        bmiRanges,
        bmrRanges,
        dcrRanges,
        fitnessGoals
      );

      if (result.status === 200) {
        toast.success("Program updated succesfully", {
          autoClose: 1000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
        localStorage.removeItem("cday");
        localStorage.removeItem("cweek");
        setTimeout(() => {
          navigate(`/programmdetail/${id}`);
        }, 2000);
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setisLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  const submitProgramm = () => {
    if (!name) {
      toast.error("Please enter program name", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    }

    //  else if(!isFree) {
    //   toast.error("Please select program is paid or free",{
    //       autoClose:2000,
    //       pauseOnHover:true,
    //       draggable:true,
    //       position:toast.POSITION.TOP_CENTER
    //     });
    //  }
    else if (isFree == "0" && price === 0) {
      toast.error("Please add price value", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (assign === "groups" && !groupId) {
      toast.error("Please select a group", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      if (selectedVideoFile) {
        // Upload first, then save with uploaded URL
        setShowVideoUploadPopup(true);
        return;
      }
      editProg(
        id,
        name,
        usersIds.join(","),
        image,
        description,
        video,
        groupId,
        isFree,
        price,
        isFree == "0" ? lock : "",
        communityId,
        programStartDate,
        numberOfWeeks,
        isOpenSource, // allow both Free & Paid to be Public/Private
        // New tag values
        activityLevels,
        ageRanges,
        genders,
        bmiRanges,
        bmrRanges,
        dcrRanges,
        fitnessGoals
      );
    }
  };

  // get community list

  useEffect(() => {
    userCommunity();
  }, []);
  const userCommunity = async () => {
    try {
      const result = await Services.getUserCommunity();
      console.log("comunity", result);
      if (result.status === 200) {
        setCommunityList(result?.data?.data);
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  // get community list

  useEffect(() => {
    userGroups();
  }, []);
  const userGroups = async () => {
    try {
      const result = await Services.getUserGroups();

      if (result.status === 200) {
        setGrouplist(result?.data?.data?.listing);
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="wrapper-dashboard">
      {isLoading && (
        <div className="loading-overlay">
          <div className="loader"></div>
        </div>
      )}
      <ToastContainer />

      <div className="edit-program-container">
        {/* Back button and page title */}
        <div className="edit-program-header">
          <button
            type="button"
            className="back-button"
            onClick={() => {
              const isModified = () => {
                if (!initialValues) return false;
                if (name !== initialValues.name) return true;
                if (description !== initialValues.description) return true;
                if (image !== initialValues.image) return true;
                if (price !== initialValues.price) return true;
                if (numberOfWeeks !== initialValues.numberOfWeeks) return true;
                if (programStartDate !== initialValues.programStartDate) return true;
                if (communityId !== initialValues.communityId) return true;
                if (groupId !== initialValues.groupId) return true;
                if (assign !== initialValues.assign) return true;
                if (isOpenSource !== initialValues.isOpenSource) return true;
                if (selectedFile) return true;
                if (usersIds.length !== (initialValues.usersIds?.length || 0)) return true;
                if (JSON.stringify(activityLevels) !== JSON.stringify(initialValues.activityLevels)) return true;
                if (JSON.stringify(ageRanges) !== JSON.stringify(initialValues.ageRanges)) return true;
                if (JSON.stringify(genders) !== JSON.stringify(initialValues.genders)) return true;
                if (JSON.stringify(bmiRanges) !== JSON.stringify(initialValues.bmiRanges)) return true;
                if (JSON.stringify(bmrRanges) !== JSON.stringify(initialValues.bmrRanges)) return true;
                if (JSON.stringify(dcrRanges) !== JSON.stringify(initialValues.dcrRanges)) return true;
                if (JSON.stringify(fitnessGoals) !== JSON.stringify(initialValues.fitnessGoals)) return true;
                return false;
              };
              if (isModified()) {
                setErrorMessage("You have modified data. Going back will discard all changes. Do you want to continue?");
                setErrorModal(true);
                setPendingBack(true);
                return;
              }
              navigate(-1);
            }}
          >
            <span className="back-icon">&larr;</span>
            Back
          </button>
          <h1 className="page-title">Edit Program</h1>
        </div>

        {/* Error Modal */}
        {showErrorModal && pendingBack && (
          <ErrorModal
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            setErrorModal={setErrorModal}
            actionButtonTitle="Yes, Discard"
            handleOK={() => {
              setPendingBack(false);
              navigate(-1);
            }}
          />
        )}

        <div className="form-card">
          
          <div className="form-grid">
            <div className="basic-info-section">
              <div className="form-group">
                <label className="form-label">Program name</label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="form-input"
                  placeholder="Enter program name"
                />
              </div>
            </div>
          </div>

           <div className="form-grid">
              <div className="form-group">
                <label className="form-label">Select a community</label>
                <select
                  onChange={handleCommunityChange}
                  className="form-select"
                  value={communityId || ""}
                >
                  <option value="">Select a community</option>
                  {communitylist?.map((option) => (
                    <option key={option?.id} value={option?.id}>
                      {option?.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label className="form-label">Number of weeks</label>
                <select
                  className="form-select"
                  value={numberOfWeeks}
                  onChange={(e) => setNumberOfWeeks(e.target.value)}
                >
                  <option value="">Select weeks</option>
                  {[...Array(12)].map((_, i) => (
                    <option key={i + 1} value={i + 1}>
                      {i + 1} week{i > 0 ? 's' : ''}
                    </option>
                  ))}
                </select>
              </div>
            </div>
         

          {/* Form Fields */}
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Program start date</label>
              <input
                type="date"
                value={programStartDate}
                onChange={(e) => setprogramStartDate(e.target.value)}
                className="form-input"
              />
            </div>
          </div>


                    {/* Form Fields */}
          <div className="form-grid">
            
            <div className="form-group">
              <label className="form-label">Program price</label>
              <div className="radio-group">
                <label className="radio-item">
                  <input
                    type="radio"
                    value="1"
                    checked={isFree == "1"}
                    onChange={handleFree}
                    className="radio-input"
                  />
                  Free
                </label>
                <label className="radio-item">
                  <input
                    type="radio"
                    value="0"
                    checked={isFree == "0"}
                    onChange={handleFree}
                    className="radio-input"
                  />
                  Paid
                </label>
              </div>
              {isFree == "0" && (
                <div className="price-input-section">
                  <label className="form-label">Price (USD)</label>
                  <input
                    type="number"
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                    className="form-input"
                    placeholder="Enter price"
                    min="0"
                    step="0.01"
                  />
                </div>
              )}
            </div>

            {window.localStorage.getItem("corporate_identifier") != '23w024s' && (
              <div className="form-group">
                <label className="form-label">Privacy</label>
                <div className="radio-group">
                  <label className="radio-item">
                    <input
                      type="radio"
                      name="visibility"
                      value="1"
                      checked={isOpenSource == 1}
                      onChange={() => handleOpenSource(1)}
                      className="radio-input"
                    />
                    Public
                  </label>
                  <label className="radio-item">
                    <input
                      type="radio"
                      name="visibility"
                      value="0"
                      checked={isOpenSource == 0}
                      onChange={() => handleOpenSource(0)}
                      className="radio-input"
                    />
                    Private
                  </label>
                </div>
              </div>
            )}

            {/* {isFree == "0" && (
              <div className="form-group">
                <label className="form-label">
                  Future weeks
                  <span className="tooltip-container">
                    <i className="fa-solid fa-circle-info tooltip-icon"></i>
                    <span className="tooltip-text">
                      You can lock future weeks if you want users should only
                      view/add progress of current week
                    </span>
                  </span>
                </label>
                <div className="radio-group">
                  <label className="radio-item">
                    <input
                      type="radio"
                      value="0"
                      checked={lock == "0"}
                      onChange={handleLock}
                      className="radio-input"
                    />
                    Unlock
                  </label>
                  <label className="radio-item">
                    <input
                      type="radio"
                      value="1"
                      checked={lock == "1"}
                      onChange={handleLock}
                      className="radio-input"
                    />
                    Lock
                  </label>
                </div>
              </div>
            )} */}

          </div>



          {/* Description Section */}
          <div className="description-section" style={{ marginTop: '20px' }}>
            <div className="form-group">
              <label className="form-label">Description</label>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className="form-textarea"
                placeholder="Describe your program..."
                rows={5}
              />
            </div>
          </div>

          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">YouTube video link</label>
              <input
                type="url"
                value={video && video.includes('firebasestorage.googleapis.com') ? '' : video}
                onChange={(e) => setVideo(e.target.value)}
                className="form-input"
                placeholder="https://youtube.com/watch?v=..."
              />
            </div>
          </div>

          {/* Media Section - Photo and Video moved here */}
          <div className="media-section">
            {/* Photo Upload - moved from top-section */}
            <div 
              className={`image-upload-section ${image || selectedimage ? 'has-image' : ''}`}
              onClick={() => document.getElementById('file-input').click()}
            >
              <input
                type="file"
                id="file-input"
                onChange={handleFileChange}
                className="file-input"
                accept="image/*"
              />
              {image || selectedimage ? (
                <div className="image-preview-container">
                  <img
                    src={image ? getImageUrl(image, BASE_URL_MEDIA) : selectedimage}
                    alt="Program"
                    className="image-preview"
                  />
                  <div className="change-image-overlay">
                    <div className="change-image-text">
                      📷<br />
                      Click to change image
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <label className="image-upload-label">Please select a photo</label>
                  <div className="upload-placeholder">
                    <div className="upload-icon">📁</div>
                    <div className="upload-text">Click to upload image</div>
                    <div className="upload-subtext">PNG, JPG, GIF up to 10MB</div>
                  </div>
                </>
              )}
            </div>

            {/* Program Video Upload - moved here from form-grid */}
            <div className={`pw_upload-container ${selectedVideoUrl || video ? "pw_has-media" : ""}`}>
              <label className="pw_upload-label">Program Video</label>
              <span className="pw_upload-help">Upload a video file or use the link field above</span>

              {(selectedVideoUrl || video) && (
                <button
                  type="button"
                  className="pw_change-btn"
                  onClick={handleProgramDivClick}
                  title="Change video"
                >
                  <i className="fa fa-pencil"></i>
                </button>
              )}

              <div onClick={handleProgramDivClick} style={{ cursor: "pointer" }}>
                <input
                  ref={fileInputRef}
                  type="file"
                  accept="video/*"
                  style={{ display: "none" }}
                  onChange={handleProgramSelectVideo}
                />

                {!selectedVideoUrl && !video ? (
                  <>
                    <div className="pw_upload-icon">
                      <i className="fa fa-video-camera"></i>
                    </div>
                    <div className="pw_upload-text">Upload Video</div>
                    <div className="pw_upload-subtext">
                      Click to select a program video
                    </div>
                  </>
                ) : selectedVideoUrl ? (
                  <>
                    <video className="pw_video-preview" controls src={selectedVideoUrl} />
                    <div className="pw_upload-subtext">Click to change video</div>
                  </>
                ) : (
                  <>
                    {video && !(
                    video.includes("youtube.com") ||
                    video.includes("youtu.be")
                    ) && (
                      <video className="pw_video-preview" controls src={video} />
                    )}
                    <div className="pw_upload-subtext">Click to change video</div>
                  </>
                )}
              </div>
            </div>
          </div>

          {/* Assignment Section */}
          <div className="search-section form-group">
            <label className="form-label">Create program for</label>
            <div className="radio-group">
              <label className="radio-item">
                <input
                  type="radio"
                  value="self"
                  checked={assign === "self"}
                  onChange={handleAssign}
                  className="radio-input"
                />
                For myself
              </label>
              <label className="radio-item">
                <input
                  type="radio"
                  value="users"
                  checked={assign === "users"}
                  onChange={handleAssign}
                  className="radio-input"
                />
                Assign to others
              </label>
              <label className="radio-item">
                <input
                  type="radio"
                  value="groups"
                  checked={assign === "groups"}
                  onChange={handleAssign}
                  className="radio-input"
                />
                For groups
              </label>
            </div>

            {/* User Search Section */}
            {assign === "users" && (
              <div className="search-section">
                <div className="form-group">
                  <label className="form-label">Search users</label>
                  <input
                    type="text"
                    value={userinput}
                    onChange={handleuserinputChange}
                    placeholder="Type to search users..."
                    className="form-input"
                  />
                </div>

                {/* Selected Users */}
                {selectedusers?.length > 0 && (
                  <ul className="selected-users-list">
                    {selectedusers?.map((suser) => (
                      <li key={suser?.id} className="selected-user-item">
                        <img
                          src={suser?.image ? getImageUrl(suser?.image, BASE_URL_MEDIA) : gymimage}
                          alt={suser?.name}
                          className="selected-user-avatar"
                        />
                        <span>{suser?.name}</span>
                        <button
                          className="remove-user-btn"
                          onClick={() => removeUser(suser)}
                          type="button"
                        >
                          ×
                        </button>
                      </li>
                    ))}
                  </ul>
                )}

                {/* Users Dropdown */}
                {users?.length > 0 && (
                  <div className="users-dropdown">
                    <button
                      className="close-dropdown-btn"
                      onClick={() => setUsers([])}
                      type="button"
                    >
                      ×
                    </button>
                    <ul className="users-list">
                      {users?.map((user) => (
                        <li
                          key={user?.id}
                          className={`user-item ${selectedusers.includes(user) ? "selected" : ""}`}
                          onClick={() => toggleItem(user)}
                        >
                          <img
                            src={user?.image ? getImageUrl(user?.image, BASE_URL_MEDIA) : gymimage}
                            alt={user?.name}
                            className="user-avatar"
                          />
                          <span className="user-name">{user?.name}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            )}

            {/* Group Selection */}
            {assign === "groups" && (
              <div className="search-section">
                <div className="form-group">
                  <label className="form-label">Select a group</label>
                  <select
                    onChange={handleGroupChange}
                    className="form-select"
                    value={groupId || ""}
                  >
                    <option value="">Select a group</option>
                    {groupList?.map((option) => (
                      <option key={option?.id} value={option?.id}>
                        {option?.title}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}
          </div>

          {/* Program Tags Section */}
          <div className="search-section">
            <ProgramTagsSection
              activityLevels={activityLevels} setActivityLevels={setActivityLevels}
              ageRanges={ageRanges} setAgeRanges={setAgeRanges}
              genders={genders} setGenders={setGenders}
              bmiRanges={bmiRanges} setBmiRanges={setBmiRanges}
              bmrRanges={bmrRanges} setBmrRanges={setBmrRanges}
              dcrRanges={dcrRanges} setDcrRanges={setDcrRanges}
              fitnessGoals={fitnessGoals} setFitnessGoals={setFitnessGoals}
            />
          </div>

          {/* Submit Button */}
          <div className="submit-section">
            <button
              className="submit-button"
              onClick={submitProgramm}
              disabled={isdisabled}
              type="button"
            >
              Update Program
            </button>
          </div>
        </div>
      </div>
      {showVideoUploadPopup && selectedVideoFile && (
      <VideoUploadPopup
        videoFile={selectedVideoFile}
        workoutId={id}
        onClose={handleCloseVideoUploadPopup}
        onVideoUploaded={handleProgramVideoUploaded}
      />
    )}
    </div>
  );
};

export default EditProgramm;
